import axios from 'axios'
import CryptoJS from 'crypto-js'
import { get, getS3, post } from '../helpers/FetchHelper'

import { ClearStringNumber } from '../helpers/ClearStringNumber'
import { DateListHelper } from '../helpers/DateListHelper'
import { DateStringFormat } from '../helpers/DateStringFormat'
import { ParserAmenitiesToSave, ParserUnitiesImagesToSave } from '../helpers/ParserHelper'

const baseUrl = process.env.REACT_APP_API_CLUB_URL
// const baseUrl = 'http://localhost:3333/dev/dashboard/';
const s3Url = process.env.REACT_APP_IMAGES_URL

export const getListTags = async () => {
  try {
    const url = `${baseUrl}get/tags`
    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}
export const getPartnerCitysMovies = async () => {
  try {
    const url = `${baseUrl}get/partnerCitysMovies`
    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const getCategoriesList = async type => {
  try {
    const url = `${baseUrl}get/${type}`
    return await get(url)
  } catch (e) {
    console.log({ error: e })
    return []
  }
}

export const selectResponsibleList = async () => {
  try {
    const url = `${baseUrl}get/responsibleList`
    return await get(url)
  } catch (e) {
    console.log('error:', e)
    return []
  }
}

export const getClassificationList = async () => {
  try {
    const url = `${baseUrl}get/partnerClassification`
    return await get(url)
  } catch (e) {
    console.log('error:', e)
    return []
  }
}

export const getAmenitiesList = async () => {
  try {
    const url = `${baseUrl}get/amenities`
    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const validatePaymentOrder = async path => {
  try {
    const url = `${s3Url}${path}`
    // console.log(url);
    const response = await getS3(url)
    // console.log('RESPONSE', response);
    const bytes = CryptoJS.AES.decrypt(response, '(ClubeGazeta2020@#$!GazetadoPovoSistemas)')
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
    // console.log("decryptedData: ", decryptedData);
    return JSON.parse(decryptedData)
  } catch (e) {
    console.log(e)
    return { error: 'Ocorreu algum erro.' }
  }
}

export const validateCpf = async cpf => {
  try {
    const url = `${baseUrl}subscribeValidator/check/${cpf}`
    return await get(url)
  } catch (e) {
    console.log(e)
    return { error: 'Ocorreu algum erro.' }
  }
}

export const refundPaymentOrder = async body => {
  try {
    const url = `${baseUrl}subscribeValidator/refund/`
    return await post(url, body)
  } catch (e) {
    console.log(e)
    return { error: 'Ocorreu algum erro.' }
  }
}

export const createValidateCpf = async data => {
  try {
    const {
      totalValue,
      discountedValue,
      userData,
      score,
      gifts,
      partnerUnitId,
      code,
      movieTicketsId,
      idVoucher
    } = data
    console.log('UserData', userData)

    const body = {
      name: userData.name,
      partnerUnitId,
      digitalUserID: userData.userId,
      subscribeUserID: userData.subscriptionId,
      score,
      totalValue,
      discountedValue,
      code,
      gifts,
      movieTicketsId,
      idVoucher
    }
    const url = `${baseUrl}subscribeValidator/save/`
    return await post(url, body)
  } catch (e) {
    return ''
  }
}

export const getValidatedCpf = async unityId => {
  try {
    const url = `${baseUrl}subscribeValidator/partnerUnit/${unityId}`

    console.log('url', url)

    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const createPartner = async partner => {
  try {
    let body = {
      ...partner,
      birthContact: partner.birthContact ? DateStringFormat(partner.birthContact) : null,
      cnpj: partner.cnpj ? ClearStringNumber(partner.cnpj) : '',
      latitude: partner.latLong.lat,
      longitude: partner.latLong.long,
      phoneNumberContact: partner.phoneNumberContact
        ? ClearStringNumber(partner.phoneNumberContact)
        : '',
      zipcode: partner.zipcode ? ClearStringNumber(partner.zipcode) : ''
    }

    if (partner.id) {
      body = { ...body, id: partner.id }
    }

    console.log('partnerBody', body)

    const url = `${baseUrl}partner`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const publishPartner = async (id, situation) => {
  try {
    const url = `${baseUrl}partner/update/${id}`
    const body = { situation }
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getPartnersList = async (page = null, limit = null) => {
  try {
    let url = `${baseUrl}get/partner`

    if (page && limit) {
      url = `${url}/${page}/${limit}/14`
    }

    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const getMovieTicketsOrder = async (page = null, limit = null) => {
  try {
    let url = `${baseUrl}get/movieTicketsOrder`

    if (page && limit) {
      url = `${url}/${page}/${limit}/1`
    }

    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const getWhiteLabelList = async (page = null, limit = null) => {
  try {
    let url = `${baseUrl}get/whiteLabel`

    if (page && limit) {
      url = `${url}/${page}/${limit}`
    }

    return await get(url)
  } catch (e) {
    console.error('error', e)
  }
}

export const getPartnerById = async partnerId => {
  try {
    const url = `${baseUrl}partner/${partnerId}`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const createUnity = async unity => {
  try {
    console.log('unityToSend ->', unity)

    const partnerData = await getPartnerById(unity.partnerId)
    const { logo } = partnerData

    let partnerUnitImagens = []
    if (unity.partnerUnitImagens.length > 0) {
      partnerUnitImagens = ParserUnitiesImagesToSave(unity.partnerUnitImagens)
    }

    let partnerUnitAmenities = []
    if (unity.partnerUnitAmenities.length > 0) {
      partnerUnitAmenities = ParserAmenitiesToSave(unity.partnerUnitAmenities)
    }

    let partnerUnityOpeningHours = []
    if (unity.partnerUnityOpeningHours.length > 0) {
      partnerUnityOpeningHours = DateListHelper(unity.partnerUnityOpeningHours)
    }

    const body = {
      ...unity,
      logo,
      birthContact: unity.birthContact ? DateStringFormat(unity.birthContact) : null,
      cnpj: unity.cnpj ? ClearStringNumber(unity.cnpj) : '',
      latitude: unity.latLong.lat,
      longitude: unity.latLong.long,
      partnerUnitAmenities,
      partnerUnitImagens,
      partnerUnityOpeningHours,
      phoneNumberContact: unity.phoneNumberContact
        ? ClearStringNumber(unity.phoneNumberContact)
        : '',
      zipcode: unity.zipcode ? ClearStringNumber(unity.zipcode) : '',
      userCompanyEmail: unity.unityCompanyEmail || unity.userCompanyEmail
    }

    if (unity.id) {
      body.id = unity.id
    }

    console.log('unityBody', body)
    const url = `${baseUrl}create-partner-unit`

    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const publishUnit = async (id, situation) => {
  try {
    const url = `${baseUrl}unit/update/${id}`
    const body = { situation }
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getUnityById = async unityId => {
  try {
    const url = `${baseUrl}partnerUnit/${unityId}`
    const data = await get(url)

    const { Partner } = data

    return {
      ...data,
      discountAmount: Partner.discountAmount,
      description: Partner.description
    }
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const addEvent = async body => {
  try {
    const url = `${baseUrl}events`
    return await post(url, body)
  } catch (e) {
    console.log(e)
    return { error: 'Ocorreu algum erro ao criar o Evento.' }
  }
}

export const getEventById = async id => {
  try {
    const url = `${baseUrl}events/${id}`
    return await get(url)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const publishEvent = async (id, situation) => {
  try {
    const url = `${baseUrl}event/update/${id}`

    const body = { situation }

    return await post(url, body)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const getEventsList = async () => {
  try {
    const url = `${baseUrl}get/events`

    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const getParentalRatingList = async () => {
  try {
    const url = `${baseUrl}get/parentalRating`
    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const createEventProducer = async name => {
  try {
    const url = `${baseUrl}create/eventsProducers`
    const body = { name }
    return await post(url, body)
  } catch (e) {
    console.log(e)
    return null
  }
}

export const createEventPlace = async body => {
  try {
    const url = `${baseUrl}create/eventsPlaces`

    console.log('placeBody', body)

    return await post(url, body)
  } catch (e) {
    console.log(e)
    return null
  }
}

export const getEventsProducerList = async () => {
  try {
    const url = `${baseUrl}get/eventsProducer`
    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const getEventsPlacesList = async () => {
  try {
    const url = `${baseUrl}get/eventsPlaces`

    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}

export const checkEmail = async str => {
  try {
    const url = `${baseUrl}validatorFields/email/${str}`

    const res = await get(url)
    const { available } = res

    return available
  } catch (e) {
    return true
  }
}

export const checkSlug = async str => {
  try {
    const url = `${baseUrl}validatorFields/slug/${str}`
    const res = await get(url)
    const { available } = res

    return available
  } catch (e) {
    console.log(e)
    return true
  }
}

export const getUnitiesList = async () => {
  const url = `${baseUrl}get/allPartner`
  const list = await get(url)

  return list.map(partner => partner.PartnerUnits.map(unity => ({ ...unity, partner }))).flat()
}

export const createScript = async body => {
  const url = `${baseUrl}create/scripts`
  return post(url, body)
}

export const getScriptList = async () => {
  try {
    const url = `${baseUrl}get/scripts`
    return await get(url)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const createMoment = async body => {
  console.log('moment', body)
  const url = `${baseUrl}create/moments`
  return post(url, body)
}

export const createChallenge = async body => {
  console.log('challenge', body)
  const url = `${baseUrl}create/challenges`
  return post(url, body)
}

export const getMomentsList = async () => {
  try {
    const url = `${baseUrl}get/moments`
    return await get(url)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const createPushNotification = async body => {
  try {
    const url = `${baseUrl}sendPushNotification`
    console.log('body', body)
    return await post(url, body)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const deletePushNotification = async body => {
  try {
    const url = `${baseUrl}deletePushNotification`
    return await post(url, body)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const getPushNotificationsList = async () => {
  try {
    const url = `${baseUrl}get/pushNotification`
    return await get(url)
  } catch (e) {
    console.log(e)
    return false
  }
}

export const getUsersList = async () => {
  try {
    const url = `${baseUrl}get/users`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const createUser = async body => {
  try {
    const url = `${baseUrl}user`
    return post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getUsersGroupList = async () => {
  try {
    const url = `${baseUrl}get/users-groups`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const searchSubscription = async str => {
  try {
    const url = `${baseUrl}clientesGazeta/${encodeURIComponent(str)}`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const createClientImage = async body => {
  try {
    const url = `${baseUrl}create/partnerUnitImagens`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const createClientValidations = async body => {
  try {
    const url = `${baseUrl}create/clientGazetaValidations`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const addOrEditTheme = async body => {
  try {
    const url = `${baseUrl}create/whiteLabel`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getThemesList = async () => {
  try {
    const url = `${baseUrl}get/whiteLabel`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const getSearch = async (type, value, userGroup = null) => {
  try {
    const url = `${baseUrl}search/${type}/${encodeURI(value)}/${userGroup}`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const getOffersList = async () => {
  try {
    const url = `${baseUrl}get/offersData`
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const addOrEditOffer = async body => {
  try {
    const url = `${baseUrl}create/offersData`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getMuralList = async (page = null, limit = null) => {
  try {
    let url = `${baseUrl}get/whiteLabelMural`

    if (page && limit) {
      url = `${url}/${page}/${limit}`
    }
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const getHighlightList = async (page = null, limit = null, whiteLabelId=null) => {
  try {
    let url = `${process.env.REACT_APP_API_CORE}highlights/dash`

    if (page && limit) {
      url = `${url}/${page}/${limit}`
    }
    if(whiteLabelId){
      url = `${url}?whiteLabelId=${whiteLabelId}`
    }
    return await get(url)
  } catch (e) {
    console.error('error', e)
    console.log('err aqui:', e)
    return []
  }
}

export const removeHighlight = async id => {
  try {
    await get(`${baseUrl}remove/highlights/${id}`)
  } catch (error) {
    return false
  }
}

export const addOrEditMural = async body => {
  try {
    const url = `${baseUrl}create/whiteLabelMural`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getNewsList = async (page = null, limit = null) => {
  try {
    let url = `${baseUrl}get/whiteLabelNews`

    if (page && limit) {
      url = `${url}/${page}/${limit}`
    }
    return await get(url)
  } catch (e) {
    console.error('error', e)
    return []
  }
}

export const addOrEditNews = async body => {
  try {
    const url = `${baseUrl}create/whiteLabelNews`
    return await post(url, body)
  } catch (e) {
    console.error('error', e)
    return false
  }
}

export const getQuizzes = async () => {
  try {
    const url = `${baseUrl}get/quiz`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const getQuizReplies = async (quizId, page = null, limit = null) => {
  page = page || 'null'
  limit = limit || 'null'

  try {
    const url = `${baseUrl}get/quizReplies/${page}/${limit}/${quizId}`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const addOrEditQuiz = async body => {
  try {
    const url = `${baseUrl}create/quiz`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const createPayment = async body => {
  try {
    const url = `${baseUrl}create/Paymentorder`
    return await post(url, body)
  } catch (e) {
    console.log('error', e.message)
    return false
  }
}

export const getPaymentListByUnit = async unitId => {
  try {
    const url = `${baseUrl}get/paymentsList/${unitId}`
    return await get(url)
  } catch (e) {
    console.log('error', e.message)
    return []
  }
}

export const getCouponsListByUnit = async partnerId => {
  try {
    const url = `${baseUrl}get/couponsList/${partnerId}`
    return await get(url)
  } catch (e) {
    console.log('error', e.message)
    return []
  }
}

export const getVouchers = async () => {
  try {
    const url = `${baseUrl}get/couponsBook`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const addOrEditVoucher = async body => {
  try {
    const url = `${baseUrl}create/couponsBook`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const getVoucherStaticFile = async offerId => {
  try {
    const url = `${s3Url}api/repository/coupons/byOffer/${offerId}.json`
    return await fetch(url, {
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const getHomeValidationsList = async () => {
  try {
    const url = `${baseUrl}get/homeValidation`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const addOrEditHomeValidation = async body => {
  try {
    const url = `${baseUrl}create/homeValidation`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const getHomePartnersList = async () => {
  try {
    const url = `${baseUrl}get/homePartners`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const saveHomePartnersList = async body => {
  try {
    const url = `${baseUrl}create/homePartners`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const getMovies = async () => {
  try {
    const response = await get(`${baseUrl}get/movies`)

    return response
  } catch (error) {
    return false
  }
}

export const removeMovie = async id => {
  try {
    await get(`${baseUrl}remove/movie/${id}`)
  } catch (error) {
    return false
  }
}

export const addMovie = async data => {
  try {
    const response = await post(`${baseUrl}create/movie`, data)

    return response
  } catch (error) {
    return false
  }
}

export const updateMovie = async data => {
  try {
    await post(`${baseUrl}create/movieUpdate`, data)
  } catch (error) {
    return false
  }
}

export const getMovieSession = async id => {
  try {
    const response = await get(`${baseUrl}sessionMovie/${id}`)

    return response
  } catch (error) {
    return false
  }
}

export const removeMovieSession = async id => {
  try {
    await get(`${baseUrl}remove/movieSessions/${id}`)
  } catch (error) {
    return false
  }
}

export const addMovieSession = async data => {
  try {
    await post(`${baseUrl}create/movieSession`, data)
  } catch (error) {
    return false
  }
}

export const updateMovieSession = async data => {
  try {
    const res = await post(`${baseUrl}create/movieSessionUpdate`, data)

    console.log('res', res)
  } catch (error) {
    return false
  }
}

export const getPartnerUnit = async () => {
  try {
    const response = axios.get(
      'https://gdp-dev-clube.s3.amazonaws.com/portal/descontos/lazer/cinemas/list.json'
    )

    return response
  } catch (error) {
    return false
  }
}
export const cancelPaymentOrder = async body => {
  try {
    const url = `${baseUrl}create/cancelPaymentOrder`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const getMovieTicketsGroups = async () => {
  try {
    const url = `${baseUrl}get/movieTicketsGroups`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const getMovieTickets = async groupId => {
  try {
    const url = `${baseUrl}movieTickets/${groupId}`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const addOrEditMovieTickets = async body => {
  try {
    const url = `${baseUrl}create/movieTickets`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const addOrEditCommunicationMaterial = async body => {
  try {
    const url = `${baseUrl}create/communicationMaterial`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const getCommunicationMaterialsList = async () => {
  try {
    const url = `${baseUrl}get/communicationMaterial`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const getPartnersUnits = async () => {
  try {
    const url = `${baseUrl}get/partnerUnits`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const getLandingPages = async () => {
  try {
    const url = `${baseUrl}get/landingPages`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const getLandingPageDetails = async id => {
  try {
    const url = `${baseUrl}landingPage/${id}`
    return await get(url)
  } catch (e) {
    console.log('error', e)
    return []
  }
}

export const checkLandingPagePath = async (path, landingPageId) => {
  try {
    const url = `${baseUrl}get/checkLandingPagePath/${path.trim().replace(/^\/+|\/+$/g, '')}/${
      landingPageId || 'XXX'
    }`
    const data = await get(url)
    return data.available
  } catch (e) {
    console.log('error', e)
    return false
  }
}

export const addOrEditLandingPage = async body => {
  try {
    const url = `${baseUrl}create/landingPage`
    return await post(url, body)
  } catch (e) {
    console.log('error', e)
    return false
  }
}
